module.exports = __webpack_public_path__ + "img/blue_ingredients_d_origine_naturelle.9e4eb33.svg";